import styled from 'styled-components'
import layout from '../../tokens/v2/layout'

export const Logo = styled.div`
  align-items: flex-start;
  display: flex;
  height: 6rem;
  justify-content: center;
  margin-bottom: 8rem;

  &.is-alt {
    height: 5.6rem;
    margin-bottom: ${layout.spacing.sm};
    justify-content: ${(props) => (props.theme.collapsed ? 'center' : 'left')};
  }
`

export const Image = styled.img`
  height: ${(props) => (props.theme.collapsed ? 'auto' : '6.0rem')};
  width: ${(props) => (props.theme.collapsed ? '4.8rem' : 'auto')};

  &.is-alt {
    height: ${(props) => (props.theme.collapsed ? 'auto' : '5.2rem')};
    width: ${(props) => (props.theme.collapsed ? '4.2rem' : 'auto')};
  }
`
